import { render, staticRenderFns } from "./AliasForm.vue?vue&type=template&id=2c30c231&scoped=true&"
import script from "./AliasForm.vue?vue&type=script&lang=js&"
export * from "./AliasForm.vue?vue&type=script&lang=js&"
import style0 from "./AliasForm.vue?vue&type=style&index=0&id=2c30c231&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c30c231",
  null
  
)

export default component.exports